<template>
  <div class="cuurentScore-gauge">
    <div class="cuurentScore-container">
      <div
        class="cuurentScore-progress"
        :style="`width: ${currentScore}%; background-color: ${currentScore >= 80 ? '#f88' : '#aaa'}`"
      ></div>
      <div
        class="cuurentScore"
        :style="`${currentScore === null ? `color: #bbb`: ``}`"
      >{{`${currentScore !== null ? Math.ceil(currentScore) + '点' : '未採点'}`}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentScore: null
    };
  },
  mounted() {
    this.setNewScore(null);
  },
  methods: {
    setNewScore(score) {
      this.currentScore = score;
    }
  },
  beforeDestroy() {
    this.currentScore = null;
  }
};
</script>

<style lang="scss" scoped>
.cuurentScore-gauge {
  transition: all 0.3s ease;
  width: 220px;
  /* background-color: #fafafa; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 4px;
  align-items: center;
  position: relative;
  .cuurentScore {
    width: 100%;
    font-size: 1rem;
  }
}
.cuurentScore-container {
  width: 100%;
  height: 4px;
  background-color: #eee;
  .cuurentScore-progress {
    transition: all 0.7s ease;
    height: 100%;
    /* background-color: #f88; */
  }
}
</style>
